import {combineReducers} from 'redux';

import adBreaks from '../../VideoAudioQC/Timeline/AdBreaks/Redux/AdBreaksReducer';
import markup from '../../VideoAudioQC/Timeline/Markup/Redux/MarkupReducer';
import audioTracks from '../../VideoAudioQC/Timeline/AudioTracks/Redux/AudioTracksReducer';
import thumbnails from '../../VideoAudioQC/Timeline/Thumbnails/Redux/ThumbnailsReducer';
import selectedMarker from '../../VideoAudioQC/Timeline/Redux/TimelineReducer';
import blackFrames from '../../VideoAudioQC/Timeline/BlackFrames/Redux/BlackFramesReducer';
import qcReport from '../../VideoAudioQC/Timeline/QCReport/Redux/QCReportReducer';

const timelineStore = combineReducers({
    thumbnails,
    adBreaks,
    markup,
    audioTracks,
    selectedMarker,
    blackFrames,
    qcReport,
});

export default timelineStore;
